export default "/yt-weeth.10c6bf5a7eaedcc1ab212453423f7383.svg";